import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import { firebase, db, storage, auth, currentUser } from '@/firebase/firebase'
import dbs from '@/firebase/firestore'
import FieryVuex from "fiery-vuex"
import VueMoment from 'vue-moment'
import { mapState, mapGetters } from "vuex"
import stripe from '@/stripe/stripe'
import ContentSheet from "@/components/ContentSheet.vue"
import SetupPaymentMethodBanner from '@/components/SetupPaymentMethodBanner.vue'
import LoadScript from 'vue-plugin-load-script'
import Helpers from '@/helpers'

Vue.use(LoadScript)
Vue.use(VueMoment)
Vue.use(FieryVuex)

Vue.prototype.$helpers = Helpers
// @ts-ignore
Vue.$helpers = Helpers
Vue.prototype.$stripe = stripe
// @ts-ignore
Vue.$stripe = stripe
Vue.prototype.$auth = auth
// @ts-ignore
Vue.$auth = auth
Vue.prototype.$dbs = dbs
// @ts-ignore
Vue.$dbs = dbs
Vue.prototype.$firebase = firebase
// @ts-ignore
Vue.$firebase = firebase

Vue.config.productionTip = false

Vue.component( 'content-sheet', ContentSheet )
Vue.component( 'setup-payment-method-banner', SetupPaymentMethodBanner )

Vue.mixin({
	computed: {
		...mapState({
			// @ts-ignore It does exist .. just not yet (parse error below)
			currentUser: state => state.user.current
    }),
    ...mapGetters({
      // @ts-ignore
      currentUserID: 'user/uid',
      isAgent: 'user/agent',
      // @ts-ignore
      isAdmin: 'user/admin',
      // @ts-ignore
      isSuperAdmin: 'user/superAdmin',
      hasSubscription: 'stripe/hasSubscription',
      hasPaymentMethods: 'stripe/hasPaymentMethods',
      paymentMethodsInit: 'stripe/paymentMethodsInit',
    }),
		isMobile() {
			return window.innerWidth && window.innerWidth < 768
		}
	}
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
